// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import { SharedListFragmentDoc, SharedListMemberFragmentDoc } from '../fragments/SharedList.generated';
import { MaterialDetailFragmentDoc } from './MaterialDetailQuery.generated';
import { AvailabilitiesFragmentDoc } from '../fragments/ProductPricing.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type GetSharedListsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetSharedListsInput>;
}>;


export type GetSharedListsQuery = { __typename?: 'Query', getSharedLists: { __typename?: 'SharedListsPayload', count: number, sharedLists: Array<{ __typename?: 'SharedList', listId: string, ownerName: string, ownerId: string, name: string, description?: string | null, lastUpdatedDate: number, createdDate: number, members?: Array<string> | null, invitations?: Array<string> | null, deadline?: number | null, coOwners?: Array<string> | null }> } };

export type GetSharedListInvitationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSharedListInvitationsQuery = { __typename?: 'Query', getSharedListInvitations: { __typename?: 'SharedListsPayload', count: number, sharedLists: Array<{ __typename?: 'SharedList', listId: string, ownerName: string, ownerId: string, name: string, description?: string | null, lastUpdatedDate: number, createdDate: number, members?: Array<string> | null, invitations?: Array<string> | null, deadline?: number | null, coOwners?: Array<string> | null }> } };

export type GetSharedListQueryVariables = Types.Exact<{
  listId: Types.Scalars['ID']['input'];
  showPricing?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetSharedListQuery = { __typename?: 'Query', getSharedList?: { __typename?: 'SharedListDetail', listId: string, ownerId: string, name: string, description?: string | null, lastUpdatedDate: number, createdDate: number, invitations?: Array<string> | null, currency?: string | null, displaySubmitQuoteButton?: boolean | null, membersDone?: Array<string> | null, deadline?: number | null, reminderFrequencyDays?: Array<number> | null, coOwners?: Array<string> | null, ownerDetail: { __typename?: 'SharedListMember', id: string, name: string, email?: string | null }, membersDetail?: Array<{ __typename?: 'SharedListMember', id: string, name: string, email?: string | null }> | null, sharedListItems: Array<{ __typename?: 'SharedListItem', listItemId: string, lastUpdatedBy: string, lastUpdatedDate: number, createdBy: string, createdByName: string, createdDate: number, quantity: number, itemNote?: string | null, currency?: string | null, listPrice?: number | null, netPrice?: number | null, price?: number | null, hidePriceMessageKey?: string | null, type: Types.CartItemType, configurationId?: string | null, productConfiguration?: Record<string, unknown> | null, material: { __typename?: 'Material', id: string, number: string, name?: string | null, isMarketplace?: boolean | null, displaySellerName?: string | null, marketplaceOfferId?: string | null, marketplaceSellerId?: string | null, description?: string | null, product: string, packageSize?: string | null, shipsToday?: boolean | null, freeFreight?: boolean | null, linearFormula?: string | null, empiricalFormula?: string | null, casNumber?: string | null, molecularWeight?: string | null, erpType?: Array<string | null> | null, substanceKey?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null }, image: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } }, availabilityMessages?: Array<{ __typename?: 'MaterialAvailability', date?: number | null, key: Types.MaterialAvailabilityKey, plantLoc?: string | null, quantity?: number | null, displayFromLink?: boolean | null, displayInquireLink?: boolean | null, messageType?: string | null, contactInfo?: { __typename?: 'MaterialContactInfo', contactPhone?: string | null, contactEmail?: string | null } | null, availabilityOverwriteMessage?: { __typename?: 'AvailabilityOverwriteMessage', messageKey?: string | null, messageValue?: string | null, messageVariable1?: string | null, messageVariable2?: string | null, messageVariable3?: string | null } | null, supplementaryMessage?: { __typename?: 'MaterialSupplementaryMessage', messageKey?: string | null, messageValue?: string | null, messageVariable1?: string | null, messageVariable2?: string | null, messageVariable3?: string | null } | null }> | null, configurationDetail?: { __typename?: 'ProductConfigurationDetail', confType?: string | null, productType?: string | null, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null }> } | null }> } | null };

export type SharedListItemFragment = { __typename?: 'SharedListItem', listItemId: string, lastUpdatedBy: string, lastUpdatedDate: number, createdBy: string, createdByName: string, createdDate: number, quantity: number, itemNote?: string | null, currency?: string | null, listPrice?: number | null, netPrice?: number | null, price?: number | null, hidePriceMessageKey?: string | null, type: Types.CartItemType, configurationId?: string | null, productConfiguration?: Record<string, unknown> | null, material: { __typename?: 'Material', id: string, number: string, name?: string | null, isMarketplace?: boolean | null, displaySellerName?: string | null, marketplaceOfferId?: string | null, marketplaceSellerId?: string | null, description?: string | null, product: string, packageSize?: string | null, shipsToday?: boolean | null, freeFreight?: boolean | null, linearFormula?: string | null, empiricalFormula?: string | null, casNumber?: string | null, molecularWeight?: string | null, erpType?: Array<string | null> | null, substanceKey?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null }, image: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } }, availabilityMessages?: Array<{ __typename?: 'MaterialAvailability', date?: number | null, key: Types.MaterialAvailabilityKey, plantLoc?: string | null, quantity?: number | null, displayFromLink?: boolean | null, displayInquireLink?: boolean | null, messageType?: string | null, contactInfo?: { __typename?: 'MaterialContactInfo', contactPhone?: string | null, contactEmail?: string | null } | null, availabilityOverwriteMessage?: { __typename?: 'AvailabilityOverwriteMessage', messageKey?: string | null, messageValue?: string | null, messageVariable1?: string | null, messageVariable2?: string | null, messageVariable3?: string | null } | null, supplementaryMessage?: { __typename?: 'MaterialSupplementaryMessage', messageKey?: string | null, messageValue?: string | null, messageVariable1?: string | null, messageVariable2?: string | null, messageVariable3?: string | null } | null }> | null, configurationDetail?: { __typename?: 'ProductConfigurationDetail', confType?: string | null, productType?: string | null, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null }> } | null };

export type SharedListDetailFragment = { __typename?: 'SharedListDetail', listId: string, ownerId: string, name: string, description?: string | null, lastUpdatedDate: number, createdDate: number, invitations?: Array<string> | null, currency?: string | null, displaySubmitQuoteButton?: boolean | null, membersDone?: Array<string> | null, deadline?: number | null, reminderFrequencyDays?: Array<number> | null, coOwners?: Array<string> | null, ownerDetail: { __typename?: 'SharedListMember', id: string, name: string, email?: string | null }, membersDetail?: Array<{ __typename?: 'SharedListMember', id: string, name: string, email?: string | null }> | null, sharedListItems: Array<{ __typename?: 'SharedListItem', listItemId: string, lastUpdatedBy: string, lastUpdatedDate: number, createdBy: string, createdByName: string, createdDate: number, quantity: number, itemNote?: string | null, currency?: string | null, listPrice?: number | null, netPrice?: number | null, price?: number | null, hidePriceMessageKey?: string | null, type: Types.CartItemType, configurationId?: string | null, productConfiguration?: Record<string, unknown> | null, material: { __typename?: 'Material', id: string, number: string, name?: string | null, isMarketplace?: boolean | null, displaySellerName?: string | null, marketplaceOfferId?: string | null, marketplaceSellerId?: string | null, description?: string | null, product: string, packageSize?: string | null, shipsToday?: boolean | null, freeFreight?: boolean | null, linearFormula?: string | null, empiricalFormula?: string | null, casNumber?: string | null, molecularWeight?: string | null, erpType?: Array<string | null> | null, substanceKey?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null }, image: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } }, availabilityMessages?: Array<{ __typename?: 'MaterialAvailability', date?: number | null, key: Types.MaterialAvailabilityKey, plantLoc?: string | null, quantity?: number | null, displayFromLink?: boolean | null, displayInquireLink?: boolean | null, messageType?: string | null, contactInfo?: { __typename?: 'MaterialContactInfo', contactPhone?: string | null, contactEmail?: string | null } | null, availabilityOverwriteMessage?: { __typename?: 'AvailabilityOverwriteMessage', messageKey?: string | null, messageValue?: string | null, messageVariable1?: string | null, messageVariable2?: string | null, messageVariable3?: string | null } | null, supplementaryMessage?: { __typename?: 'MaterialSupplementaryMessage', messageKey?: string | null, messageValue?: string | null, messageVariable1?: string | null, messageVariable2?: string | null, messageVariable3?: string | null } | null }> | null, configurationDetail?: { __typename?: 'ProductConfigurationDetail', confType?: string | null, productType?: string | null, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null }> } | null }> };

export type GetSharedListInfoQueryVariables = Types.Exact<{
  listId: Types.Scalars['ID']['input'];
}>;


export type GetSharedListInfoQuery = { __typename?: 'Query', getSharedList?: { __typename?: 'SharedListDetail', invitations?: Array<string> | null, coOwners?: Array<string> | null, ownerDetail: { __typename?: 'SharedListMember', id: string, name: string, email?: string | null }, membersDetail?: Array<{ __typename?: 'SharedListMember', id: string, name: string, email?: string | null }> | null, sharedListItems: Array<{ __typename?: 'SharedListItem', brand?: string | null, materialNumber: string, materialDescription?: string | null, materialName?: string | null, quantity: number, type: Types.CartItemType, configurationId?: string | null, productConfiguration?: Record<string, unknown> | null, configurationDetail?: { __typename?: 'ProductConfigurationDetail', confType?: string | null, productType?: string | null, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null }> } | null }> } | null };

export const SharedListItemFragmentDoc = gql`
    fragment SharedListItem on SharedListItem {
  listItemId
  lastUpdatedBy
  lastUpdatedDate
  createdBy
  createdByName
  createdDate
  material {
    ...MaterialDetail
  }
  quantity
  itemNote
  availabilityMessages {
    ...Availabilities
  }
  currency
  listPrice
  netPrice
  price
  hidePriceMessageKey
  type
  configurationId
  configurationDetail {
    configuration {
      name
      value
    }
    confType
    productType
  }
  productConfiguration
}
    ${MaterialDetailFragmentDoc}
${AvailabilitiesFragmentDoc}`;
export const SharedListDetailFragmentDoc = gql`
    fragment SharedListDetail on SharedListDetail {
  listId
  ownerId
  ownerDetail {
    ...SharedListMember
  }
  name
  description
  lastUpdatedDate
  createdDate
  membersDetail {
    ...SharedListMember
  }
  invitations
  currency
  sharedListItems {
    ...SharedListItem
  }
  displaySubmitQuoteButton
  membersDone
  deadline
  reminderFrequencyDays
  coOwners
}
    ${SharedListMemberFragmentDoc}
${SharedListItemFragmentDoc}`;
export const GetSharedListsDocument = gql`
    query GetSharedLists($input: GetSharedListsInput) {
  getSharedLists(input: $input) {
    count
    sharedLists {
      ...SharedList
    }
  }
}
    ${SharedListFragmentDoc}`;
export type GetSharedListsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSharedListsQuery, GetSharedListsQueryVariables>, 'query'>;

    export const GetSharedListsComponent = (props: GetSharedListsComponentProps) => (
      <ApolloReactComponents.Query<GetSharedListsQuery, GetSharedListsQueryVariables> query={GetSharedListsDocument} {...props} />
    );
    

/**
 * __useGetSharedListsQuery__
 *
 * To run a query within a React component, call `useGetSharedListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedListsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSharedListsQuery(baseOptions?: Apollo.QueryHookOptions<GetSharedListsQuery, GetSharedListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedListsQuery, GetSharedListsQueryVariables>(GetSharedListsDocument, options);
      }
export function useGetSharedListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedListsQuery, GetSharedListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedListsQuery, GetSharedListsQueryVariables>(GetSharedListsDocument, options);
        }
export function useGetSharedListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSharedListsQuery, GetSharedListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSharedListsQuery, GetSharedListsQueryVariables>(GetSharedListsDocument, options);
        }
export type GetSharedListsQueryHookResult = ReturnType<typeof useGetSharedListsQuery>;
export type GetSharedListsLazyQueryHookResult = ReturnType<typeof useGetSharedListsLazyQuery>;
export type GetSharedListsSuspenseQueryHookResult = ReturnType<typeof useGetSharedListsSuspenseQuery>;
export type GetSharedListsQueryResult = Apollo.QueryResult<GetSharedListsQuery, GetSharedListsQueryVariables>;
export const GetSharedListInvitationsDocument = gql`
    query GetSharedListInvitations {
  getSharedListInvitations {
    count
    sharedLists {
      ...SharedList
    }
  }
}
    ${SharedListFragmentDoc}`;
export type GetSharedListInvitationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>, 'query'>;

    export const GetSharedListInvitationsComponent = (props: GetSharedListInvitationsComponentProps) => (
      <ApolloReactComponents.Query<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables> query={GetSharedListInvitationsDocument} {...props} />
    );
    

/**
 * __useGetSharedListInvitationsQuery__
 *
 * To run a query within a React component, call `useGetSharedListInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedListInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedListInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSharedListInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>(GetSharedListInvitationsDocument, options);
      }
export function useGetSharedListInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>(GetSharedListInvitationsDocument, options);
        }
export function useGetSharedListInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>(GetSharedListInvitationsDocument, options);
        }
export type GetSharedListInvitationsQueryHookResult = ReturnType<typeof useGetSharedListInvitationsQuery>;
export type GetSharedListInvitationsLazyQueryHookResult = ReturnType<typeof useGetSharedListInvitationsLazyQuery>;
export type GetSharedListInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetSharedListInvitationsSuspenseQuery>;
export type GetSharedListInvitationsQueryResult = Apollo.QueryResult<GetSharedListInvitationsQuery, GetSharedListInvitationsQueryVariables>;
export const GetSharedListDocument = gql`
    query GetSharedList($listId: ID!, $showPricing: Boolean) {
  getSharedList(listId: $listId, showPricing: $showPricing) {
    ...SharedListDetail
  }
}
    ${SharedListDetailFragmentDoc}`;
export type GetSharedListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSharedListQuery, GetSharedListQueryVariables>, 'query'> & ({ variables: GetSharedListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSharedListComponent = (props: GetSharedListComponentProps) => (
      <ApolloReactComponents.Query<GetSharedListQuery, GetSharedListQueryVariables> query={GetSharedListDocument} {...props} />
    );
    

/**
 * __useGetSharedListQuery__
 *
 * To run a query within a React component, call `useGetSharedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedListQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      showPricing: // value for 'showPricing'
 *   },
 * });
 */
export function useGetSharedListQuery(baseOptions: Apollo.QueryHookOptions<GetSharedListQuery, GetSharedListQueryVariables> & ({ variables: GetSharedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedListQuery, GetSharedListQueryVariables>(GetSharedListDocument, options);
      }
export function useGetSharedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedListQuery, GetSharedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedListQuery, GetSharedListQueryVariables>(GetSharedListDocument, options);
        }
export function useGetSharedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSharedListQuery, GetSharedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSharedListQuery, GetSharedListQueryVariables>(GetSharedListDocument, options);
        }
export type GetSharedListQueryHookResult = ReturnType<typeof useGetSharedListQuery>;
export type GetSharedListLazyQueryHookResult = ReturnType<typeof useGetSharedListLazyQuery>;
export type GetSharedListSuspenseQueryHookResult = ReturnType<typeof useGetSharedListSuspenseQuery>;
export type GetSharedListQueryResult = Apollo.QueryResult<GetSharedListQuery, GetSharedListQueryVariables>;
export const GetSharedListInfoDocument = gql`
    query GetSharedListInfo($listId: ID!) {
  getSharedList(listId: $listId) {
    ownerDetail {
      ...SharedListMember
    }
    membersDetail {
      ...SharedListMember
    }
    invitations
    coOwners
    sharedListItems {
      brand
      materialNumber
      materialDescription
      materialName
      quantity
      type
      configurationId
      configurationDetail {
        configuration {
          name
          value
        }
        confType
        productType
      }
      productConfiguration
    }
  }
}
    ${SharedListMemberFragmentDoc}`;
export type GetSharedListInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>, 'query'> & ({ variables: GetSharedListInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSharedListInfoComponent = (props: GetSharedListInfoComponentProps) => (
      <ApolloReactComponents.Query<GetSharedListInfoQuery, GetSharedListInfoQueryVariables> query={GetSharedListInfoDocument} {...props} />
    );
    

/**
 * __useGetSharedListInfoQuery__
 *
 * To run a query within a React component, call `useGetSharedListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedListInfoQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetSharedListInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSharedListInfoQuery, GetSharedListInfoQueryVariables> & ({ variables: GetSharedListInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>(GetSharedListInfoDocument, options);
      }
export function useGetSharedListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>(GetSharedListInfoDocument, options);
        }
export function useGetSharedListInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>(GetSharedListInfoDocument, options);
        }
export type GetSharedListInfoQueryHookResult = ReturnType<typeof useGetSharedListInfoQuery>;
export type GetSharedListInfoLazyQueryHookResult = ReturnType<typeof useGetSharedListInfoLazyQuery>;
export type GetSharedListInfoSuspenseQueryHookResult = ReturnType<typeof useGetSharedListInfoSuspenseQuery>;
export type GetSharedListInfoQueryResult = Apollo.QueryResult<GetSharedListInfoQuery, GetSharedListInfoQueryVariables>;